class MobileNavigation {
  constructor() {
    this.dom = {
      mobileNavToggle: document.querySelector('.header__icon.hide-lg'),
      mobileNavigation: document.querySelector('.mobile-navigation'),
      drilldownButtons: document.querySelectorAll('.mobile-navigation__drilldown'),
      breadcrumbBacks: document.querySelectorAll('.mobile-navigation__breadcrumb'),
      headerLogo: document.querySelector('.mobile-navigation__logo'),
      promoBlock: document.querySelector('.mobile-navigation__promos'),
      secondaryMenu: document.querySelector('.mobile-navigation__menu--secondary'),
      primaryMenu: document.querySelector('.mobile-navigation__menu--primary'),
      closeIcon: document.querySelector('.mobile-navigation__close-icon'),
      body: document.body,
      submenus: document.querySelectorAll('.mobile-navigation__submenu'),
    };

    this.dom.submenuMap = new Map();
    this.dom.submenus.forEach(menu => {
      this.dom.submenuMap.set(menu.dataset.parent, menu);
    });

    this.activeTimeout = null;
    this.init();
  }

  init() {
    this.addEventListeners();
  }

  addEventListeners() {
    if (this.dom.mobileNavToggle) {
      this.dom.mobileNavToggle.addEventListener('click', this.handleMobileNavToggle.bind(this));
    }
    this.dom.drilldownButtons.forEach(button => {
      button.addEventListener('click', this.handleDrilldown.bind(this));
    });
    this.dom.breadcrumbBacks.forEach(backBtn => {
      backBtn.addEventListener('click', this.handleBreadcrumbBack.bind(this));
    });
    if (this.dom.headerLogo) {
      this.dom.headerLogo.addEventListener('click', this.handleLogoClick.bind(this));
    }
    if (this.dom.closeIcon) {
      this.dom.closeIcon.addEventListener('click', this.handleCloseIconClick.bind(this));
    }
    if (this.dom.mobileNavigation) {
      this.dom.mobileNavigation.addEventListener('transitionend', this.handleTransitionEnd.bind(this));
    }
  }

  toggleBodyOverflow(enable) {
    this.dom.body.style.overflow = enable ? 'hidden' : '';
  }

  handleTransitionEnd(e) {
    if (e.propertyName === 'transform' && 
        !this.dom.mobileNavigation.classList.contains('is-active')) {
      this.toggleBodyOverflow(false);
    }
  }

  handleMobileNavToggle(e) {
    e.preventDefault();
    const isOpening = !this.dom.mobileNavigation.classList.contains('is-active');
    if (isOpening) this.toggleBodyOverflow(true);
    this.dom.mobileNavigation.classList.toggle('is-active');
  }

  handleCloseIconClick(e) {
    e.preventDefault();
    this.dom.mobileNavigation.classList.remove('is-active');
    this.hideAllElements();
    this.showMainElements();
  }

  handleDrilldown(e) {
    e.preventDefault();
    const target = e.currentTarget.dataset.target;
    this.hideAllElements();
    const targetMenu = this.dom.submenuMap.get(target);
    if (targetMenu) {
      targetMenu.classList.add('is-active');
      targetMenu.classList.remove('hide');
    }
  }

  handleBreadcrumbBack(e) {
    e.stopPropagation();
    this.dom.submenus.forEach(menu => {
      menu.classList.remove('is-active');
      menu.classList.add('hide');
    });
    this.showMainElements();
  }

  handleLogoClick(e) {
    if (e.currentTarget.href === 'javascript:void(0)') {
      e.preventDefault();
      this.hideAllElements();
      this.showMainElements();
    }
  }

  hideAllElements() {
    document.querySelectorAll('.mobile-navigation__menu, .mobile-navigation__submenu').forEach(el => {
      el.classList.remove('is-active');
      el.classList.add('hide');
    });
    if (this.dom.promoBlock) this.dom.promoBlock.classList.add('hide');
    if (this.dom.secondaryMenu) this.dom.secondaryMenu.classList.add('hide');
  }

  showMainElements() {
    if (this.dom.primaryMenu) {
      this.dom.primaryMenu.classList.add('is-active');
      this.dom.primaryMenu.classList.remove('hide');
    }
    if (this.dom.promoBlock) this.dom.promoBlock.classList.remove('hide');
    if (this.dom.secondaryMenu) this.dom.secondaryMenu.classList.remove('hide');
  }
}
class DesktopNavigation {
  constructor() {
    this.dom = {
      navContainer: document.querySelector('.navigation-dropdown'),
      header: document.querySelector('.header-new'),
      body: document.body,
    };
    this.activeTimeout = null;
    this.activeDropdowns = new Set();
    this.init();
  }

  init() {
    this.addEventListeners();
  }

  addEventListeners() {
    document.body.addEventListener('mouseover', (e) => {
      const item = e.target.closest('.nav-item-list');
      if (item) this.handleNavItemMouseEnter(item);
    });

    document.body.addEventListener('mouseover', (e) => {
      const trigger = e.target.closest('.header-nav__item.has-dropdown');
      if (trigger) this.handleDropdownMouseEnter(trigger);
    });
    document.body.addEventListener('mouseout', (e) => {
      const trigger = e.target.closest('.header-nav__item.has-dropdown');
      if (trigger) this.handleDropdownMouseLeave(e);
    });

    if (this.dom.navContainer) {
      this.dom.navContainer.addEventListener('mouseenter', () => {
        this.dom.header?.classList.add('is-active');
      });
      this.dom.navContainer.addEventListener('mouseleave', this.handleNavigationDropdownLeave.bind(this));
    }

    if (this.dom.header) {
      this.dom.header.addEventListener('mouseleave', this.handleHeaderMouseLeave.bind(this));
    }

    document.body.addEventListener('mouseover', (e) => {
      const icon = e.target.closest('.header__icon');
      if (icon) this.handleHeaderIconHover(icon, 'enter');
    });
    document.body.addEventListener('mouseout', (e) => {
      const icon = e.target.closest('.header__icon');
      if (icon) this.handleHeaderIconHover(icon, 'leave');
    });

    const leaveHandler = this.handlePotentialListWrapperLeave.bind(this);
    document.body.addEventListener('pointerout', leaveHandler);
    document.body.addEventListener('mouseout', leaveHandler); 

    window.addEventListener('blur', this.handleWindowBlur.bind(this));
  }

  resetNavItems(wrapperEl) {
    const items = wrapperEl.querySelectorAll('.nav-item-list');
    items.forEach(i => i.classList.remove('is-active', 'is-not-active'));
    if (this.activeDropdowns.size === 0) {
      this.dom.header?.classList.remove('is-active');
    }
  }

  handlePotentialListWrapperLeave(e) {
    const fromWrapper = e.target && e.target.closest && e.target.closest('.list-wrapper');
    if (!fromWrapper) return;

    const to = e.relatedTarget;
    if (to && to.closest && to.closest('.list-wrapper') === fromWrapper) return;

    this.resetNavItems(fromWrapper);
  }

  handleHeaderIconHover(icon, type) {
    const allIcons = document.querySelectorAll('.header__icon');
    if (type === 'enter') {
      allIcons.forEach(i => {
        if (i === icon) {
          i.classList.add('hover', 'ann', 'is-active');
          i.classList.remove('is-not-active');
        } else {
          i.classList.add('is-not-active');
          i.classList.remove('hover', 'ann', 'is-active');
        }
      });
    } else {
      allIcons.forEach(i => {
        i.classList.remove('hover', 'ann', 'is-active', 'is-not-active');
      });
    }
  }

  handleNavItemMouseEnter(item) {
    cancelAnimationFrame(this.activeTimeout);
    if (item.classList.contains('shop-all')) return;

    const parentGroup = item.closest('.list-wrapper');
    if (!parentGroup) return;

    this.dom.header?.classList.add('is-active');

    const siblingItems = parentGroup.querySelectorAll('.nav-item-list:not(.shop-all)');
    siblingItems.forEach(navItem => {
      navItem.classList.remove('is-active', 'is-not-active');
      if (navItem !== item) navItem.classList.add('is-not-active');
    });

    const currentActive = parentGroup.querySelector('.header-nav__item.is-active');
    const currentTitle = currentActive?.querySelector('.menu-title');
    const newTitle = item.querySelector('.menu-title');

    if (currentTitle && newTitle) {
      currentTitle.classList.add('menu-title-exit');
      newTitle.classList.add('menu-title-enter');
      setTimeout(() => {
        currentTitle.classList.remove('menu-title-exit');
        newTitle.classList.remove('menu-title-enter');
      }, 300);
    }

    this.activeTimeout = requestAnimationFrame(() => {
      item.classList.add('is-active');
    });
  }

  handleDropdownMouseEnter(trigger) {
    const dropdownId = trigger.dataset.dropdownId;
    const dropdownContent = document.querySelector(`.navigation-dropdown__content[data-dropdown-content="${dropdownId}"]`);
    if (!dropdownContent) return;

    this.dom.header?.classList.add('is-active');
    this.dom.body.classList.add('overlay-is-active');

    document.querySelectorAll('.navigation-dropdown__content').forEach(d => {
      d.classList.remove('is-active');
      this.activeDropdowns.delete(d);
    });

    dropdownContent.classList.add('is-active');
    this.dom.navContainer?.classList.add('is-active');
    this.activeDropdowns.add(dropdownContent);
  }

  handleDropdownMouseLeave(e) {
    const relatedTarget = e.relatedTarget;
    if (!relatedTarget ||
        (!relatedTarget.closest('.navigation-dropdown') &&
         !relatedTarget.closest('.header-nav__item.has-dropdown'))) {
      this.closeAllDropdowns();
    }
  }

  handleNavigationDropdownLeave(e) {
    const relatedTarget = e.relatedTarget;
    if (!relatedTarget || !relatedTarget.closest('.header-nav__item.has-dropdown')) {
      this.closeAllDropdowns();
    }
  }

  handleHeaderMouseLeave(e) {
    const relatedTarget = e.relatedTarget;
    if (!relatedTarget ||
        (!relatedTarget.closest('.header-new') &&
         !relatedTarget.closest('.navigation-dropdown'))) {
      this.closeAllDropdowns();
    }
  }

  handleWindowBlur() {
    cancelAnimationFrame(this.activeTimeout);
    this.closeAllDropdowns();
  }

  closeAllDropdowns() {
    this.activeDropdowns.forEach(dropdown => dropdown.classList.remove('is-active'));
    this.activeDropdowns.clear();
    this.dom.navContainer?.classList.remove('is-active');
    document.querySelectorAll('.nav-item-list').forEach(navItem => {
      navItem.classList.remove('is-active', 'is-not-active');
    });
    this.dom.body.classList.remove('overlay-is-active');
    this.dom.header?.classList.remove('is-active');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.mobile-navigation')) {
    new MobileNavigation();
  }

  if (document.querySelector('.nav-item-list')) {
    new DesktopNavigation();
  }
});